var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dcw-testimonial-slider"},[_c('DcwSwiper',{staticClass:"dcw-testimonial-slider__wrapper",attrs:{"options":_vm.swiperOptions,"active-slide":_vm.swiperInfo.activeSlide},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var slide = ref.slide;
return [_c('DcwTestimonialSlide',{attrs:{"slide":slide}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }